import {gsap} from "gsap";

const animationLeave = (container) => {
    const col_left = container.querySelector("main#main");
    const col_right = container.querySelector("#right-column");
    const tl = gsap.timeline({
        defaults : {
            duration: .3,
            ease: "power2.out",
        }
    });
    tl.to(col_left, {alpha:0, y:'-2%'})
    tl.to(col_right, {alpha:0})

    return tl;
    
}

export default animationLeave;
